import {GroupCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/GroupCancer';
import {NewYorkCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/NewYorkCancer';
import {OrdinaryCancer} from 'ApplicationEntry/models/ProductsRiders/Cancer/OrdinaryCancer';

export type Cancer = OrdinaryCancer | GroupCancer | NewYorkCancer;

type ExhaustiveCancerOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryCancer) => TReturn;
  Group: (group: GroupCancer) => TReturn;
  NewYork: (newYork: NewYorkCancer) => TReturn;
};

type PartialCancerOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryCancer) => TReturn;
  Group?: (group: GroupCancer) => TReturn;
  NewYork?: (newYork: NewYorkCancer) => TReturn;
  _: (app: Cancer) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: CancerByTypeOptions<TReturn>
): options is ExhaustiveCancerOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type CancerByTypeOptions<TReturn> = PartialCancerOptionsByType<TReturn> | ExhaustiveCancerOptionsByType<TReturn>;

export const matchCancerByType = <TReturn>(options: CancerByTypeOptions<TReturn>) => (app: Cancer): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryCancer':
    case 'ValidOrdinaryCancer':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupCancer':
    case 'ValidGroupCancer':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkCancer':
    case 'ValidNewYorkCancer':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidCancer = (cancer: Cancer) =>
  cancer.key === 'ValidOrdinaryCancer' || cancer.key === 'ValidGroupCancer' || cancer.key === 'ValidNewYorkCancer';
